module.exports = __webpack_public_path__ + "static/media/logo.8de7406d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 727
// module chunks = 5